module.exports = __webpack_public_path__ + "img/title_7.6d763472.png";